import { CmsService } from './../../../_services/cms.service';
import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { first } from 'rxjs/operators';
import { ActivatedRoute, Router } from '@angular/router';
import {ToastrService} from 'ngx-toastr';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-cms-front',
  templateUrl: './cms-front.component.html',
  styleUrls: ['./cms-front.component.scss']
})

export class CmsFrontComponent implements OnInit {
  cmsTitle = '';
  cmsDescription = '';
  slug = '';
  routeSub: Subscription;
  showContent = false;
  isLoading = false;
  constructor(private http: HttpClient,
    private route: ActivatedRoute,
    private toastr: ToastrService,
    private router: Router,
    private cmsService: CmsService) {
  }

  ngOnInit() {
    this.routeSub = this.route.params
      	.subscribe(params => {
	        this.slug = params['slug'];
	        setTimeout(() => {   
		      	this.getCmsData();
			}, 100);  
      	});
  }
  getCmsData() {
    if (this.slug) {
      this.isLoading = true;
      this.cmsService.getCmsBySlug(this.slug)
          .pipe(first())
          .subscribe(
              (response: any) => {
                this.isLoading = false;
                if (response.meta.status === true) {
                  this.showContent = true;
                  const responseData = response.data;
                  this.cmsTitle = responseData.page_title;
                  this.cmsDescription = responseData.description;
                } else {
                  this.showContent = false;
                  this.toastr.error(response.meta.message);
                }                
          },
          error => {
            this.isLoading = false;
            if (error.meta.status === false) {
              this.showContent = false;
              // this.toastr.error(error.meta.message);
            } 
      });
    }
  }
}
